import Business from "../components/Business";
import Footer from '../components/Footer';
import Slider from '../components/LandingPageScroll';
import Landing from '../components/Landing';
import PortfolioScroll from '../components/PScroll';
import styles from "../style";
import Provide from "../components/Provide";
import CTA from "../components/CTA";
import { s10 } from "../assets";

const Home = () => {
  
  return (
    <div className="bg-primary flex flex-col">
      <Landing />         
      <Provide />  
      <div className={` md:py-10 py-10`}
        style={{ 
          backgroundImage: `url(${s10})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          transform: [{ scaleX: -1 }],
          zIndex: 0,
        }}
      >             
        <Business />
      </div>
      <Slider />
      <CTA />      
      <Footer/>  
    </div>
  )
} 
export default Home;